import React from 'react';
import { Modal } from 'antd';

import useModal, { IModalPayload } from '@hooks/use-modal';

import Widget from './Widget';
import { SendHorizonal } from 'lucide-react';

const PenaltySubmissionModal = () => {
  const [modal, setModal] =
    useModal<IModalPayload<{ ids: string[]; type: string }>>('update-penalty');

  const { ids = [] } = modal?.payload || {};

  const onClose = () => {
    setModal({ isOpen: false, payload: null });
  };

  return (
    <Modal
      destroyOnClose
      centered
      width={640}
      onCancel={onClose}
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      footer={null}
      title={
        <>
          <SendHorizonal size={14} className={'mr-2'} />
          Submit invoices
        </>
      }
      visible={(modal?.isOpen && modal?.payload?.type === 'submit') || false}
    >
      <Widget ids={ids} onClose={onClose} />
    </Modal>
  );
};

export default PenaltySubmissionModal;
